import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const APP_PACKAGE = 'com.carex.market';
const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${APP_PACKAGE}`;
const APP_STORE_URL = 'https://apps.apple.com/us/app/carex-marketplace/id6758438618';

function detectPlatform() {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/i.test(ua)) return 'ios';
  return 'desktop';
}

const Listing = () => {
  const { carId } = useParams();

  useEffect(() => {
    if (!carId) return;
    if (detectPlatform() !== 'android') return;
    const fallback = encodeURIComponent(PLAY_STORE_URL);
    const intentUrl =
      `intent://www.carexmarket.com/listing/${encodeURIComponent(carId)}` +
      `#Intent;scheme=https;package=${APP_PACKAGE};` +
      `S.browser_fallback_url=${fallback};end`;
    window.location.href = intentUrl;
  }, [carId]);

  return (
    <div className="page home">
      <header className="hero">
        <div className="hero-glow" aria-hidden />
        <div className="hero-inner">
          <p className="hero-eyebrow">Marketplace · Inspire The Next Inc.</p>
          <h1 className="hero-title">
            Open this listing in <span className="hero-title-accent">CarEx</span>
          </h1>
          <p className="hero-lede">
            Get the CarEx app to view full listing details, contact the seller, and
            book trusted broker or logistics services.
          </p>
          <div className="app-badges">
            <a
              href={APP_STORE_URL}
              className="download-btn download-btn--primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="download-btn-icon" aria-hidden>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
              </span>
              App Store
            </a>
            <a
              href={PLAY_STORE_URL}
              className="download-btn download-btn--secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="download-btn-icon" aria-hidden>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 010-1.22l7.203-8.407-7.202-8.555a.996.996 0 011.22-1.185zm1.21 20.556L14.622 12 4.82 1.838a.998.998 0 011.405-1.404l11.954 6.924c.66.38.66 1.313 0 1.694L6.226 21.57a1.002 1.002 0 01-1.405-1.2zM16.803 8.09l2.168-1.268c.5-.293.813.153.496.552l-2.255 3.143 2.262 3.143c.317.399.005.845-.496.552l-2.168-1.268V8.09z" />
                </svg>
              </span>
              Google Play
            </a>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Listing;
